module.exports = __webpack_public_path__ + "img/block.f9947230.webp";